import {
  GET_ALL_MPOWER_DISCOUNTS,
  UPDATE_MPOWER_DISCOUNT,
  CREATE_MPOWER_DISCOUNT,
  UPDATE_MPOWER_DISCOUNT_PENDING
} from '../constants';

export default {
  [GET_ALL_MPOWER_DISCOUNTS](state, data) {
    state.discounts = data;
  },
  [UPDATE_MPOWER_DISCOUNT](state, data) {
    state.discounts = state.discounts.map((el) => {
      if (el._id === data._id) {
        Object.assign(el, data);
      }
      return {
        ...el
      };
    });
  },
  [CREATE_MPOWER_DISCOUNT](state, data) {
    state.discounts.push(data);
  },
  [UPDATE_MPOWER_DISCOUNT_PENDING](state, data) {
    state.pendingDiscount = data;
  }
};
